var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Layout", [
    _c("div", { staticClass: "content ep__main_content" }, [
      _c("section", { staticClass: "content" }, [
        _c("div", { staticClass: "center-content" }, [
          _c(
            "svg",
            {
              attrs: {
                width: "552",
                height: "333",
                viewBox: "0 0 552 333",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M358.563 277.5C356.869 277.495 355.197 277.124 353.66 276.413C352.124 275.701 350.762 274.665 349.667 273.377L287.113 202.799C279.869 205.939 271.874 206.947 264.072 205.704C256.271 204.461 248.991 201.018 243.09 195.783C237.19 190.548 232.917 183.739 230.777 176.161C228.636 168.583 228.717 160.553 231.01 153.02L232.941 146.645L259.257 172.869C260.068 173.664 261.159 174.109 262.296 174.109C263.432 174.109 264.524 173.664 265.334 172.869L278.51 159.748C279.307 158.941 279.754 157.854 279.754 156.721C279.754 155.588 279.307 154.501 278.51 153.693L252.184 127.478L258.59 125.554C266.152 123.27 274.213 123.191 281.818 125.327C289.424 127.463 296.257 131.724 301.509 137.607C306.761 143.49 310.213 150.748 311.457 158.524C312.701 166.3 311.685 174.268 308.528 181.487L379.4 243.864C380.631 244.901 381.631 246.183 382.336 247.627C383.04 249.072 383.434 250.648 383.492 252.253C383.55 253.858 383.27 255.458 382.671 256.949C382.072 258.44 381.167 259.79 380.014 260.912L366.846 274.033C365.764 275.127 364.475 275.997 363.053 276.592C361.631 277.187 360.105 277.496 358.563 277.5Z",
                  fill: "#BD0F72"
                }
              }),
              _c("path", {
                attrs: {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d:
                    "M358.635 98.3024L338.546 126.326V126.362C341.506 131.606 343.827 137.183 345.459 142.976L379.569 148.649V179.679L345.459 185.335C343.805 191.108 341.046 196.955 338.114 202.202L326.049 191.584C330.26 183.129 332.511 173.745 332.514 164.128C332.514 151.909 328.878 139.964 322.065 129.803C315.252 119.643 305.569 111.724 294.239 107.048C282.91 102.372 270.444 101.148 258.416 103.532C246.389 105.916 235.342 111.8 226.671 120.441C217.999 129.082 212.094 140.09 209.702 152.075C207.31 164.06 208.538 176.483 213.23 187.772C217.923 199.061 225.87 208.711 236.066 215.499C246.262 222.288 258.25 225.912 270.512 225.912C279.766 225.909 288.807 223.846 297.015 219.977L307.885 232.238C302.779 235.025 297.368 237.219 291.758 238.776L286.055 272.766H254.916L249.24 238.811C243.438 237.162 237.846 234.85 232.576 231.923L204.454 251.905L182.434 229.963L202.523 201.904C199.566 196.662 197.245 191.088 195.61 185.299L161.5 179.616V148.587L195.61 142.931C197.265 137.149 199.585 131.577 202.523 126.326L182.434 98.3024L204.454 76.3604L232.576 96.3786C237.837 93.4315 243.431 91.119 249.24 89.4902L254.916 55.5H286.055L291.794 89.4902C297.595 91.141 303.187 93.4524 308.457 96.3786L336.58 76.3604L358.635 98.3024ZM358.131 230.466L336.58 251.941L335.107 250.892L304.178 216.003C307.821 213.655 311.234 210.915 314.349 207.811C317.193 204.977 319.732 201.896 321.946 198.619L358.131 230.466Z",
                  fill: "#BD0F72"
                }
              }),
              _c("path", {
                attrs: {
                  d: "M159.127 19.2969L170.887 31.024",
                  stroke: "#C4C4C4",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }
              }),
              _c("path", {
                attrs: {
                  d: "M170.887 19.2969L159.127 31.024",
                  stroke: "#C4C4C4",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }
              }),
              _c("path", {
                attrs: {
                  d:
                    "M512.466 282.566C515.753 282.566 518.417 279.909 518.417 276.631C518.417 273.354 515.753 270.697 512.466 270.697C509.18 270.697 506.516 273.354 506.516 276.631C506.516 279.909 509.18 282.566 512.466 282.566Z",
                  stroke: "#C4C4C4",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }
              }),
              _c("path", {
                attrs: {
                  d: "M539.381 232.684L550.999 244.269",
                  stroke: "#C4C4C4",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }
              }),
              _c("path", {
                attrs: {
                  d: "M550.999 232.684L539.381 244.269",
                  stroke: "#C4C4C4",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }
              }),
              _c("path", {
                attrs: {
                  d:
                    "M203.186 16.6078C205.847 16.6078 208.003 14.457 208.003 11.8039C208.003 9.15078 205.847 7 203.186 7C200.526 7 198.369 9.15078 198.369 11.8039C198.369 14.457 200.526 16.6078 203.186 16.6078Z",
                  stroke: "#C4C4C4",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }
              }),
              _c("path", {
                attrs: {
                  d:
                    "M10.2093 191.575C15.2954 191.575 19.4186 187.463 19.4186 182.391C19.4186 177.319 15.2954 173.207 10.2093 173.207C5.12314 173.207 1 177.319 1 182.391C1 187.463 5.12314 191.575 10.2093 191.575Z",
                  stroke: "#C4C4C4",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }
              }),
              _c("path", {
                attrs: {
                  d: "M27.9199 219.826L36.7042 228.445",
                  stroke: "#C4C4C4",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }
              }),
              _c("path", {
                attrs: {
                  d: "M36.7042 219.826L27.9199 228.445",
                  stroke: "#C4C4C4",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }
              }),
              _c("path", {
                attrs: {
                  d: "M439.436 60.5117L447.795 68.9892",
                  stroke: "#C4C4C4",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }
              }),
              _c("path", {
                attrs: {
                  d: "M447.795 60.5117L439.436 68.9892",
                  stroke: "#C4C4C4",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }
              }),
              _c("path", {
                attrs: {
                  d:
                    "M405.149 52.0319C410.235 52.0319 414.358 47.9201 414.358 42.848C414.358 37.7758 410.235 33.6641 405.149 33.6641C400.063 33.6641 395.939 37.7758 395.939 42.848C395.939 47.9201 400.063 52.0319 405.149 52.0319Z",
                  stroke: "#C4C4C4",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }
              })
            ]
          ),
          _c("div", { staticClass: "maintenance-title pb-24" }, [
            _vm._v(" UNDER MAINTENANCE ")
          ]),
          _c("div", { staticClass: "maintenance-message pb-16" }, [
            _vm._v(" Sorry, we're down for maintenance. We'll be back shortly ")
          ]),
          _c("div", { staticClass: "maintenance-message" }, [
            _vm._v(
              " If you have any problem, please contact the operation team: "
            ),
            _c("span", { staticClass: "maintenance-message-tel" }, [
              _vm._v("+65 6370 1300")
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }